export const computePaginationState = ({
  posts,
  paginationMeta,
}) => {
  const paginate = posts.length >= 1;
  const paginationTotal = posts.length;
  const paginationCurrent = paginationMeta.current;

  return {
    paginate,
    paginationTotal,
    paginationCurrent,
  };
};
